import React from "react";
import { Bar } from "react-chartjs-2";
import {
	Chart,
	BarController,
	BarElement,
	CategoryScale,
	LinearScale,
	Tooltip,
	Legend,
} from "chart.js";

Chart.register(
	BarController,
	BarElement,
	CategoryScale,
	LinearScale,
	Tooltip,
	Legend 
);

const TBarChart = ({ entries, onBarClick, color, height }) => {
	const chartHeight = height ?? Math.max(240, entries.length * 36 + 60);
	const chartData = {
        labels: entries.map((e) => `${e.label} (${e.value.toFixed(2)}%)`),
        datasets: [
            {
                data: entries.map((e) => e.value),
                backgroundColor: color || "#9e9e9e",
                borderColor: "rgba(255, 255, 255, 0.54)",
                borderWidth: 1,
                borderRadius: 2.5,
            },
        ],
    };
	const options = {
		indexAxis: "y",
		maintainAspectRatio: false,
		plugins: {
			legend: {
				display: false,
			},
		},
		onClick: (event, elements) => {
			if (elements.length > 0 && onBarClick) {
				onBarClick(entries[elements[0].index].key);
			}
		},
		onHover: (event, elements) => {
			if (event.native) {
				event.native.target.style.cursor =
					elements.length > 0 && onBarClick ? "pointer" : "default";
			}
		},
		scales: {
			x: {
				beginAtZero: true,
				title: {
					display: true,
					text: "Terpenes (% of total weight)",
					font: {
						size: 20,
						weight: "bold",
					},
				},
				grid: {
					color: "rgba(112, 112, 112, 0.12)",
				},
			},
			y: {
				grid: {
					color: "rgba(112, 112, 112, 0.12)",
				},
			},
		},
	};
	return (
		<div style={{ height: `${chartHeight}px` }}>
			<Bar data={chartData} options={options} />
		</div>
	);
};

export default TBarChart;
